var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-group",class:['spacing--' + _vm.spacing, 'justify--' + _vm.justify,  'align--' + _vm.align, {'column': _vm.isColumn, 'wrap': _vm.isWrap }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }